module.exports = __webpack_public_path__ + "img/icon-pt.1b7601e0.png";